/**
 * Routes
 */

export enum Routes {
  /** Login */
  LOGIN = "/login",
  LOGIN_GUEST = "/login/guest",
  LOGIN_GUEST_VALIDATION = "/login/guest-validation",
  LOGOUT = "/logout",
  LANDING = "/landing",
  COOKUNITY_MENU = "/nextMenu",
  UNITYPASS_HUB = "/unitypass-hub",
}

export enum LoginRoutes {
  /** Login with slug */
  LOGIN = "/login/{slug}",
  LOGIN_GUEST = "/login/{slug}/guest",
  LOGIN_GUEST_VALIDATION = "/login/{slug}/guest-validation",
  LOGIN_MAGIC_LINK = "/login/{slug}/magic-link",
  LOGIN_MAGIC_LINK_VALIDATE = "/login/{slug}/magic-link/validate",
}

export enum TriviaRoutes {
  /** Introduction */
  HOME_TRIVIA = "/trivia/{slug}",

  /** Profile */
  CREATE_PROFILE = "/trivia/{slug}/create-profile",
  EDIT_PROFILE = "/trivia/{slug}/edit-profile",
  CHOOSE_AVATAR_PROFILE = "/trivia/{slug}/create-profile/choose-avatar",

  /** Game */
  GAME = "/trivia/{slug}?tab=play",
  LEADERBOARD = "/trivia/{slug}?tab=leaderboard",
  LEVEL = "/trivia/{slug}/game/level/",
  LEVEL_COMPLETED = "/trivia/{slug}/game/level/completed/",
  LEVEL_FAILED = "/trivia/{slug}/game/level/failed/",
}

export enum TriviaRoutesPublic {
  HOW_TO_PLAY = "/trivia/{slug}/how-to-play",
  TERMS_AND_CONDITIONS = "/trivia/{slug}/terms-and-conditions",
}
